module.exports = __webpack_public_path__ + "img/logo.c86bbcc8.png";